<template>
  <el-dialog width="550px" :visible.sync="visible" :title="isAdd ? '新增董监高数据' : '修改董监高数据'" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="editDataForm" style="padding-right: 50px;" :rules="isAdd ? dataRule1 : dataRule" ref="editDataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="code" label="编码" v-if="!isAdd">
        <el-input v-model="editDataForm.code" :disabled="!isAdd" placeholder="编码"></el-input>
      </el-form-item>
      <el-form-item prop="name" label="姓名">
          <el-input  v-model="editDataForm.name" :disabled="!isAdd" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="手机号">
        <el-input v-model="editDataForm.phone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="idCard" label="身份证">
        <el-input v-model="editDataForm.idCard" placeholder="身份证"></el-input>
      </el-form-item>
      <el-form-item prop="caName" label="公司名称">
        <el-input v-model="editDataForm.caName" :disabled="!isAdd" placeholder="公司名称"></el-input>
      </el-form-item>
      <el-form-item prop="typeJoin" label="职位">
        <el-input v-model="editDataForm.typeJoin" :disabled="!isAdd" placeholder="职位"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import {isEmail, isMobile, testPassword} from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
let checkPhone = (rule, value, callback) => {
    let reg = /^1[345789]\d{9}$/
    if (!reg.test(value)) {
        callback(new Error('请输入11位手机号'))
    } else {
        callback()
    }
}
export default {
  props:['dataForm'],
  data () {
    return {
      isAdd:false,
      editDataForm:{},
      visible: false,
      roleList: [],
      roleIdListDefault: [],
    }
  },
  computed: {
    dataRule () {
      return {
		      phone: [{ required: true,validator:checkPhone, message: '请输入正确的手机号', trigger: 'blur' }],
		      idCard: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' },{pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '你的身份证格式不正确' }],
      }
    },
    dataRule1 () {
      return {
          // code: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          name: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          caName: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          typeJoin: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
		      phone: [{ required: true,validator:checkPhone, message: '请输入正确的手机号', trigger: 'blur' }],
		      idCard: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' },{pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '你的身份证格式不正确' }],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      const newArr = JSON.stringify(this.dataForm)
      this.editDataForm = JSON.parse(newArr)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['editDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let url = '/sys/companyStaff/update'
        if(this.isAdd){
          url = '/sys/companyStaff/save'
        }
        let paramsForm = JSON.parse(JSON.stringify(this.editDataForm));
        this.$http.post(url, {
          ...paramsForm
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
</style>
